import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d7536af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "title luxury uppercase wc-lg innerContainer" }
const _hoisted_3 = { class: "data-cont" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottomLine innerContainer" }, null, -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "ttl fira wc-lg" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "1.00586",
    y1: "10.6213",
    x2: "20.0059",
    y2: "10.6213",
    stroke: "#F40146",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "11.0059",
    y1: "1.62134",
    x2: "11.0059",
    y2: "20.6213",
    stroke: "#F40146",
    "stroke-width": "2",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "content" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "swiper-cont" }
const _hoisted_12 = { class: "slide" }
const _hoisted_13 = { class: "img" }
const _hoisted_14 = ["srcset"]
const _hoisted_15 = ["srcset"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fira" }, "RECEPTION", -1))

import { computed } from "vue";
import SlideUpDown from "vue3-slide-up-down";
import { get, includes } from "lodash";
import { useMenuStore } from "@/store/pinia/menu";
import { handleResize } from "../../../composables/resizeHandler";
import type { ComputedRef } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";

// Define store

export default /*#__PURE__*/_defineComponent({
  props: {
    contentData: {
        type: Object,
    },
    customData: {
        type: Object,
        required: false,
    },
},
  setup(__props) {

const props = __props

/**
 * @author Tornike Jortmenadze (Jortsoft)
 */
const store = useMenuStore();

// Define props


// Define global variables
const { windowWidth } = handleResize();
const swiperOptions = {
    slidesPerView: 6.5,
    spaceBetween: 20,
    freeMode: true,
    breakpoints: {
        320: {
            slidesOffsetBefore: 20,
            slidesPerView: 2,
        },
        768: {
            slidesOffsetBefore: 20,
            slidesPerView: 3,
        },
        1024: {
            slidesOffsetBefore: 190,
            slidesPerView: 5,
        },
        1365: {
            slidesOffsetBefore: 150,
        },
        1920: {
            slidesOffsetBefore: 370,
        },
    },
    slidesOffsetBefore: 370,
};

// Reactive data
const getData = computed(() => {
    let arr = get(props, "customData")
        ? get(props, "customData.data.list")
        : get(props.contentData, "data.list");
    arr.forEach((item: { active: boolean }) => {
        item.active = false;
    });
    return arr;
});
const getHomeTitle: ComputedRef<string> = computed(() => {
    return get(props, "customData")
        ? get(props.customData, "conf.header.title")
        : get(props.contentData, "conf.header.title");
});
const checkDark = computed(() => {
    return includes(
        get(props, "customData")
            ? get(props.customData, "conf.conf")
            : get(props.contentData, "conf.conf"),
        "dark"
    );
});

// Custom functions
const dropFaq = (item: { active: boolean }): void => {
    if (item.active) {
        item.active = false;
    } else {
        getData.value.forEach((item: { active: boolean }) => {
            item.active = false;
        });
        item.active = true;
    }
    if (windowWidth.value < 1024 || window.innerWidth < 1024) {
        return;
    }
    store.triggerUpdate = !store.triggerUpdate;
    window.setTimeout(() => {
        store.triggerUpdate = !store.triggerUpdate;
    }, 400);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["faq", { dark: _unref(checkDark) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getHomeTitle)), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getData), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index
          }, [
            _hoisted_4,
            _createElementVNode("div", {
              class: _normalizeClass(["top-cont innerContainer", { active: _ctx.$get(item, 'active') }]),
              onClick: ($event: any) => (dropFaq(item))
            }, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$get(item, "title")), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["icon", { minus: item.active }])
              }, _hoisted_8, 2)
            ], 10, _hoisted_5),
            _createVNode(_unref(SlideUpDown), {
              modelValue: item.active,
              "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
              duration: 400
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "editor innerContainer",
                    innerHTML: _ctx.$get(item, 'teaser')
                  }, null, 8, _hoisted_10),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.$get(item, 'images'))
                      ? (_openBlock(), _createBlock(_unref(Swiper), {
                          key: 0,
                          "slides-per-view": 
                                        swiperOptions?.slidesPerView
                                    ,
                          "space-between": swiperOptions?.spaceBetween,
                          breakpoints: swiperOptions?.breakpoints,
                          "free-mode": swiperOptions?.freeMode,
                          slidesOffsetBefore: 
                                        swiperOptions?.slidesOffsetBefore
                                    
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (img, index) => {
                              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("picture", null, [
                                        _createElementVNode("source", {
                                          media: "(max-width:767px)",
                                          srcset: 
                                                            _ctx.$get(
                                                                img,
                                                                '0.devices.mobile'
                                                            )
                                                        
                                        }, null, 8, _hoisted_14),
                                        _createElementVNode("source", {
                                          media: "(max-width:1023px)",
                                          srcset: 
                                                            _ctx.$get(
                                                                img,
                                                                'devices.tablet'
                                                            )
                                                        
                                        }, null, 8, _hoisted_15),
                                        _createElementVNode("img", {
                                          src: 
                                                            _ctx.$get(
                                                                img,
                                                                'devices.desktop'
                                                            )
                                                        ,
                                          alt: 
                                                            _ctx.$get(img, 'title')
                                                        
                                        }, null, 8, _hoisted_16)
                                      ])
                                    ]),
                                    _hoisted_17
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["slides-per-view", "space-between", "breakpoints", "free-mode", "slidesOffsetBefore"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      ])
    ])
  ], 2))
}
}

})